import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

type MessageKey = 'errorIconAriaLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  errorIconAriaLabel: {
    defaultMessage: 'Error icon',
    description:
      'Aria label for the error icon shown when something wrong with the selected file',
    id: 'boxFileRequest.uploadField.errorIconAriaLabel',
  },
});

export default messages;
